import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGift } from '@fortawesome/free-solid-svg-icons'
import { createPortal } from 'react-dom'
import { Wheel } from 'react-custom-roulette'
import { useGetRouletteOptionsQuery } from '../../../store/api/rouletteApi'
import { getAppType, getStorageKey } from '../../../utils/appType'
import { BRANDS } from '../../../utils/brand'
import { haptic } from '../../../utils/fx'

interface RouletteWheelProps {
  show: boolean
  onStopSpinning: (selectedOption: string) => void
  onSpin: () => Promise<{ prize: string }>
  t: (key: string) => string
  prizeNumber: number
  setPrizeNumber: (prizeNumber: number) => void
}

export const WHEEL_PROPS = {
  outerBorderWidth: 6,
  outerBorderColor: '#ffffff',
  innerBorderWidth: 18,
  innerBorderColor: '#ffffff',
  radiusLineWidth: 2,
  radiusLineColor: 'rgba(255,255,255,0.6)',
  fontSize: 15,
  fontFamily: 'Nunito',
  fontWeight: 800,
  perpendicularText: false,
  textDistance: 60,
}

export const WheelHub = ({ spinning = false }: { spinning?: boolean }) => (
  <div className={`roulette-hub${spinning ? ' is-spinning' : ''}`}>
    <img src={BRANDS[getAppType()].mascot} alt='' />
  </div>
)

const RouletteWheel: React.FC<RouletteWheelProps> = ({
  show,
  onStopSpinning,
  onSpin,
  t,
  prizeNumber,
  setPrizeNumber,
}) => {
  const [mustSpin, setMustSpin] = useState(false)
  const { data = [] } = useGetRouletteOptionsQuery()

  const handleSpinClick = async () => {
    if (!mustSpin && data.length > 0) {
      try {
        haptic([10, 30, 10])
        const response = await onSpin()
        const winningPrize = response.prize

        const winningIndex = data.findIndex(
          (item) => item.option === winningPrize,
        )

        if (winningIndex !== -1) {
          setPrizeNumber(winningIndex)
          setMustSpin(true)

          localStorage.setItem(
            getStorageKey('rouletteWinningPrize'),
            winningPrize,
          )
        } else {
          console.error('Winning prize not found in options')
        }
      } catch (error) {
        console.error('Error spinning roulette:', error)
      }
    }
  }

  if (!show || data.length === 0) {
    return null
  }

  return createPortal(
    <div className='roulette-overlay'>
      <div className='roulette-glow' />
      <div className='roulette-title'>
        <FontAwesomeIcon icon={faGift} /> {t('SPIN')}!
      </div>
      <div className='roulette-container'>
        <div className='wheel-wrapper'>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={data}
            onStopSpinning={() => {
              const winningPrize =
                localStorage.getItem(getStorageKey('rouletteWinningPrize')) ||
                data[prizeNumber].option

              localStorage.removeItem(getStorageKey('rouletteWinningPrize'))
              haptic([30, 50, 30, 50, 60])
              onStopSpinning(winningPrize)
              setMustSpin(false)
            }}
            {...WHEEL_PROPS}
          />
          <WheelHub spinning={mustSpin} />
        </div>
      </div>
      <button
        className='roulette-spin'
        onClick={handleSpinClick}
        disabled={mustSpin || data.length === 0}
      >
        {mustSpin ? t('SPINNING') : t('SPIN')}
      </button>
    </div>,
    document.body,
  )
}

export default RouletteWheel
